import { ContainerModule, type ContainerModuleLoadOptions } from 'inversify';
import { CustomerChatbotDependencyTypes } from '@client/feature/customer-chatbots/customer-chatbot.dependency-types';
import { CustomerChatbotApiService } from '@client/feature/customer-chatbots/data/service/customer-chatbot.api-service';
import { CustomerChatbotVisitorIdentificationApiDataTransformer } from '@client/feature/customer-chatbots/data/transformer/customer-chatbot-visitor-identification.api-data-transformer';
import { CustomerChatbotRepository } from '@client/feature/customer-chatbots/data/repository/customer-chatbot.repository';
import type { CustomerChatbotRepositoryInterface } from '@client/feature/customer-chatbots/domain/repository/customer-chatbot.repository';
import { CustomerChatbotService } from '@client/feature/customer-chatbots/domain/service/customer-chatbot.service';
import { HubspotConversationsWidgetService } from '@client/feature/customer-chatbots/domain/service/hubspot-conversations-widget.service';

export const customerChatbotContainerModule = new ContainerModule((options: ContainerModuleLoadOptions) => {
  options
    .bind<CustomerChatbotApiService>(CustomerChatbotDependencyTypes.CustomerChatbotApiService)
    .to(CustomerChatbotApiService)
    .inSingletonScope();
  options
    .bind<CustomerChatbotVisitorIdentificationApiDataTransformer>(
      CustomerChatbotDependencyTypes.CustomerChatbotVisitorIdentificationApiDataTransformer,
    )
    .to(CustomerChatbotVisitorIdentificationApiDataTransformer)
    .inSingletonScope();
  options
    .bind<CustomerChatbotRepositoryInterface>(CustomerChatbotDependencyTypes.CustomerChatbotRepository)
    .to(CustomerChatbotRepository)
    .inSingletonScope();
  options
    .bind<HubspotConversationsWidgetService>(CustomerChatbotDependencyTypes.HubspotConversationsWidgetService)
    .to(HubspotConversationsWidgetService)
    .inSingletonScope();
  options
    .bind<CustomerChatbotService>(CustomerChatbotDependencyTypes.CustomerChatbotService)
    .to(CustomerChatbotService)
    .inSingletonScope();
});
